import { type Epic } from 'redux-observable';
import { filter, ignoreElements, tap } from 'rxjs';

const errorHandlingEpic: Epic = (action$) =>
  action$.pipe(
    filter(({ type }) => type.endsWith('/failed')),
    tap(({ type, payload }) => {
      // eslint-disable-next-line no-console
      console.error('Error occurred at action', type, 'with payload', payload);
    }),
    ignoreElements(),
  );

export default errorHandlingEpic;
